import angular from 'angular';

export function orderChannelFilter (input) {
    switch (input) {
        case "ONLINE":
            return  "general:online"
        case "IN_STORE":
            return  "general:instore"
        case "IN_STORE_CARD":
            return  "general:branded-card-instore"
        case "IN_STORE_CARD_ONLINE":
            return  "general:branded-card-ecommerce"
        case "MONEY":
            return  "general:money"
        case "CASH_APP":
            return  "general:cash-app-pay"
        default:
            return "general:unknown"
    }
}

angular.module("core.application.main")
  .filter("core_application_main_filter_orderChannel", () => orderChannelFilter);
